import { Box, SxProps, TextFieldProps as TextFieldMuiProps, Theme } from "@mui/material";
import React, { FunctionComponent } from "react";

import { ColorType, ReactChildren } from "types";

import { Label12SemiBold } from "../typography";

export const InputFieldWrapper: FunctionComponent<
  ReactChildren & {
    label: TextFieldMuiProps["label"];
    message?: string;
    color?: ColorType;
    sxLabel?: SxProps<Theme>;
    required?: boolean;
  }
> = ({ label, message, color, children, sxLabel, required }) => (
  <Box
    sx={{
      width: "100%",
    }}
  >
    {label && (
      <Label12SemiBold sx={{ ...{ mb: "4px" }, ...sxLabel }}>
        {label}{required && <span style={{ color: 'red' }}> *</span>}
      </Label12SemiBold>
    )}
    {children}
    {message && (
      <Label12SemiBold sx={{ mt: "4px" }} color={color}>
        {message}
      </Label12SemiBold>
    )}
  </Box>
);
